<template>
  <div class="start flex flex-wrap -mx-2">
    <div class="w-full max-w-full overflow-x-scroll">
      <h1 class="">Deine Bestellhistorie ({{ orderCount }})</h1>

      <div v-if="loaded && orderCount == 0" class="mt-8 flex items-center bg-green-heinz text-white text-sm font-bold px-4 py-3" role="alert">
        <svg class="fill-current w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z"/></svg>
        <p>Es befinden sich noch keine Bestellungen in deinem Archiv. Beste Zeit das zu ändern!</p>
      </div>

      <table v-for="month in orders" :key="month.caption" class="w-full mt-8">
        <caption class="text-left text-xl font-bold p-2 border-b-2">{{ month.caption }} mit {{ month.sum | pricetag }}</caption>
        <thead>
          <th class="w-1/8 text-left p-2">Datum</th>
          <th class="w-1/10 text-right p-2">Bestellnummer</th>
          <th class="w-1/10 text-right p-2">Endpreis</th>
          <th class="text-left p-2">Anbieter</th>
          <th class="w-1/6 text-left p-2">Status</th>
          <th class="w-1/8 text-left p-2">Optionen</th>
          <th class="w-1/8 text-right p-2">Bewertung</th>
        </thead>
        <tbody>
          <tr v-for="order in month.orders" :key="order.id">
            <td class="text-left p-2">{{ order.build }}</td>
            <td class="text-right p-2">#{{ order.id }}</td>
            <td class="text-right p-2">{{ order.value | pricetag }}</td>
            <td class="text-left p-2">
              <router-link :to="{ name: 'Shop', params: { hostUrl: order.hostUrl }}" class="no-underline text-black">
                {{ order.host }}
              </router-link>
            </td>
            <td class="text-left p-2">
              {{ order.status }}
              <div class="text-sm">{{ order.info }}</div>

              <ul v-if="order.timings.Bestellt">
                <li v-for="(timing, label) in order.timings" :key="label">
                  <strong>{{ label }}:</strong>
                  <template v-if="timing">{{ timing }}</template>
                  <template v-if="!timing">-</template>
                </li>
              </ul>
            </td>
            <td class="text-left p-2">
              <button v-on:click="reorder(order)" class="block text-xs font-semibold rounded-full px-4 py-1 mb-1 leading-normal bg-green-heinz border border-green-heinz text-white hover:bg-white hover:text-green-heinz hover:border-green-heinz">
                Erneut bestellen
              </button>
              <button v-if="order.paymentUrl" v-on:click="pay(order)" class="block text-xs font-semibold rounded-full px-4 py-1 mb-1 leading-normal bg-orange border border-orange-dark text-white hover:bg-white hover:text-orange-dark hover:border-orange-dark">
                Jetzt bezahlen
              </button>
              <button v-if="order.cancel" v-on:click="cancel(order)" class="block text-xs font-semibold rounded-full px-4 py-1 mb-1 leading-normal bg-orange border border-orange-dark text-white hover:bg-white hover:text-orange-dark hover:border-orange-dark">
                Stornieren
              </button>
              <button v-if="order.cancelPerRequest" v-on:click="cancelPerRequest(order)" class="block text-xs font-semibold rounded-full px-4 py-1 mb-1 leading-normal bg-orange border border-orange-dark text-white hover:bg-white hover:text-orange-dark hover:border-orange-dark">
                Stornierung anfragen
              </button>
            </td>
            <td class="text-right p-2">
              <rating v-if="order.review.reviewed" :value="order.review.quality"></rating>
              <rating v-if="order.review.reviewed" :value="order.review.time"></rating>
              <rating v-if="order.review.reviewed" :value="order.review.price"></rating>

              <button v-if="order.review.reviewable" v-on:click="review(order)" class="text-xs font-semibold rounded-full px-4 py-1 leading-normal bg-green-heinz border border-green-heinz text-white hover:bg-white hover:text-green-heinz hover:border-green-heinz">
                Jetzt bewerten
              </button>
            </td>
          </tr>
        </tbody>
        <!-- <tfoot>
          <td class="text-left p-2">Gesamt</td>
          <td class="text-right p-2">{{ month.sum | pricetag }}</td>
          <td colspan="4"></td>
        </tfoot> -->
      </table>
    </div>
  </div>
</template>

<script>
import endpoints from '../../endpoints'
import axios from 'axios'
import Rating from '../../components/Rating.vue'

export default {
  name: 'Archiv',

  data () {
    return {
      loaded: false,
      orders: [],
      orderCount: 0
    }
  },

  components: {
    'rating': Rating
  },

  created () {
    this.load()
  },

  methods: {
    load () {
      axios.post(endpoints.archive + '/' + (window.type !== 'foodi' && window.hostId > 0 ? window.hostId : ''), {})
        .then(response => {
          this.loaded = true
          this.orders = response.data.orders
          this.orderCount = response.data.count
        })
    },

    reorder (order) {
      axios.post(endpoints.reorder, { 'orderId': order.reorder })
        .then(response => {
          window.hostId = response.data.id

          this.$router.push({ name: 'Warenkorb',
            params: {
              hostUrl: order.hostUrl
            }})
        })
    },

    pay (order) {
      this.$router.push({ path: order.paymentUrl })
    },

    cancel (order) {
      if (window.confirm('Bestellung #' + order.id + ' wirklich stornieren?')) {
        axios.post(endpoints.cancel, { 'orderId': order.id })
          .then(response => {
            if (response.data.success) {
              this.load()
            } else {
              alert('Das hat leider nicht funktioniert :-(')
            }
          })
      }
    },

    cancelPerRequest (order) {
      if (window.confirm('Deine Bestellung #' + order.id + ' wurde dem Restaurant bereits übermittelt. Wir können aber für dich um eine Stornierung bitten?')) {
        axios.post(endpoints.cancelPerRequest, { 'orderId': order.id })
          .then(response => {
            if (response.data.success) {
              this.load()
            } else {
              alert('Das hat leider nicht funktioniert :-(')
            }
          })
      }
    },

    review (order) {
      this.$router.push({ name: 'Bewerten',
        params: {
          orderId: order.review.data.id,
          checksum: order.review.data.checksum
        }})
    }
  }
}
</script>

<style lang="scss" scoped>
  table {
    tbody {
      tr:nth-child(even) {
        td {
          @apply bg-grey-light;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/archive/index.vue